/**
 * Part of toolstool project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

/**
 * @param {App}    app
 * @param {Object} options
 * @constructor
 */
export function AppPlugin(app, options = {}) {
  app.config.globalProperties.numberFormat = (...args) => u.numberFormat(...args);

  app.config.globalProperties.priceFormat = (price, prefix = null, ...args) => {
    price = Number(price);
    const absNum = Math.abs(price);

    let formatted = u.numberFormat(absNum, ...args);

    if (prefix !== null) {
      formatted = prefix + formatted;
    }

    if (price < 0) {
      formatted = '-' + formatted;
    }

    return formatted;
  };
}
